import React, { Component } from 'react';
import { Theme } from '@mui/material';
import { Card, CardContent } from '@mui/material';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { RootState } from '../../setup';
import { createStyles, withStyles } from '@mui/styles';
import { FormType } from '../../constants/constants';
import AddGtsOrderForm from './addOrderForm';
import { resetGtsOrder } from '../../reducers/gtsOrderReducer';

interface IAddOrderProps {
    classes: any;
    theme: Theme;
    match: any;
    resetGtsOrder: any;
    steps: Array<number>;
    gtsOrderId?: number;
    type: FormType;
}

const styles = (theme: Theme) => createStyles({
    root: {
        width: '100%',
        marginTop: '70px',
        display: 'flex'
    },
    cardContent: {
        flex: 1,
        borderTop: '1px #ececec solid',
        borderBottom: 'none',
        marginRight: theme.spacing(5),
        marginLeft: theme.spacing(5)
    }
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
    resetGtsOrder: () => dispatch(resetGtsOrder())
});

const mapStoreToProps = (store: RootState, ownProps: IAddOrderProps) => {
    return {
        gtsOrderId: ownProps.match.params?.gtsOrderId ? Number(ownProps.match.params?.gtsOrderId) : undefined
    };
};

class AddOrder extends Component<IAddOrderProps> {
    componentWillUnmount() {
        const { resetGtsOrder } = this.props;

        resetGtsOrder();
    }

    render() {
        const { classes, steps, gtsOrderId, type } = this.props;

        return (
            <div>
                <Card className={classes.root}>
                    <CardContent className={classes.cardContent}>
                        <AddGtsOrderForm gtsOrderId={gtsOrderId} steps={steps} type={type} />
                    </CardContent>
                </Card>
            </div>
        );
    }
}
  
export default withStyles(styles)(connect(mapStoreToProps, mapDispatchToProps)(AddOrder));